import React from 'react';
import { Container, Row, Col, Card, Form} from 'react-bootstrap';
import Feedback from './Feedback';
import Progress from './ProgressBar';
import Question from './Question';
import SourceDoc from './SourceDoc';
import ModifiedDoc from './ModifiedDoc';
import Title from './Title';
import Instructions from './Instructions';
import ModificationInstruction from './ModificationInstruction';
import ModificationDetails from './ModificationDetails';
import { queryDict } from "../queryString";
import TaskComplete from './TaskComplete';

function isJsonString(str) {
    try {
        var json = JSON.parse(str);
        return (typeof json === 'object');
    } catch (e) {
        return false;
    }
}

function fetchFile(path, callback, isJson = true) {
    var httpRequest = new XMLHttpRequest();

    // Append a timestamp to the URL to prevent caching
    var cacheBustingPath = path + "?t=" + new Date().getTime();

    httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === 4) {
            if (httpRequest.status === 200) {
                var data = httpRequest.responseText;
                try {
                    if (isJsonString(data)) {
                        console.log("=> This is a json data!");
                        data = JSON.parse(data);
                    }
                } catch (error) {
                    console.log("[fetchFile] can not parse the following data as JSON:");
                    console.log(data);
                }
                try {
                    if (callback) callback(data);
                } catch (error) {
                    console.error("[fetchFile] callback function fails with detail:", error.message);
                }
            }
        }
    };
    
    // Use the cache-busting URL
    httpRequest.open('GET', cacheBustingPath);
    httpRequest.send();
}


class MainTask extends React.Component {
    instructionsOpen = false;

    n_questions = 5
    answers = {}
    userData = {
        "hit_id": 0,
        "assignment_id": 0,
        "worker_id": 0,
        "submit_time": 0,
        "control_score": 0
    }
    constructor(props) {
        super(props);
        this.state = {
            uid: '',
            original_text: '',
            modified_text: '',
            rationale: '',
            task: '',
            explanation: 'n/a',
            original_conv_as_list: [],
            
            data: {},
            instructions: {},

            // State for display.
            original_text_highlight_spans: [],
            modified_text_highlight_spans: [],
            taskCompleted: false,
            currentInstance: 0,

            // User input
            correct_modification: true,
            selected: 'empty',
            feedback: '',
            worker_modification: 'n/a',
        };

        this.handleJsonDataFile = this.handleJsonDataFile.bind(this);
        this.handleJsonInstructionFile = this.handleJsonInstructionFile.bind(this);
        this.beginTask = this.beginTask.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        // read data file
        const filePath = 'data/' + queryDict.modification_type + '/' + this.props.hash + '.json';
        console.log("data file:", filePath)
        fetchFile(filePath, this.handleJsonDataFile, true);
        // read instruction file
        const instructionFilePath = 'data/instructions.json';
        console.log("instructions:", instructionFilePath)
        fetchFile(instructionFilePath, this.handleJsonInstructionFile, true);
    }

    handleJsonInstructionFile(json) {
        if (Object.keys(this.state.instructions).length === 0) {
            this.setState( {instructions:json} )
            console.log("[handleJsonInstructionFile]:", this.state.instructions)
        }
    }

    handleJsonDataFile(json) {
        console.log("[handleJson] function invoked")
        // without the check, there can be error when the data is not loaded (Cannot read properties of undefined (reading '0') in JS)
        if (Object.keys(this.state.data).length === 0) {
            // console.log("show json data content:", json)
            this.setState({ data:json })
            // var instance = this.state.data["data"][this.state.currentInstance]
            // console.log("summary:", this.state.data["data"][this.state.currentInstance]["summary"])
            if (this.state.data["data"][this.state.currentInstance]["task"] === "dialogue_contradiction_detection") {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance]["uid"],
                    task: this.state.data["data"][this.state.currentInstance]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance]["original_last_turn"],
                    modified_text: this.state.data["data"][this.state.currentInstance]["modified_last_turn"],
                    rationale: this.state.data["data"][this.state.currentInstance]["rationale"],
                    original_conv_as_list: this.state.data["data"][this.state.currentInstance]["original_conv_as_list"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["modified_text_highlight_spans"]
                })
            } else if (this.state.data["data"][this.state.currentInstance]["task"] === "conversational_qa") {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance]["uid"],
                    task: this.state.data["data"][this.state.currentInstance]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance]["original_sentence"],
                    modified_text: this.state.data["data"][this.state.currentInstance]["modified_text"],
                    rationale: this.state.data["data"][this.state.currentInstance]["rationale"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["modified_text_highlight_spans"]
                })
            } else {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance]["uid"],
                    task: this.state.data["data"][this.state.currentInstance]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance]["original_text"],
                    modified_text: this.state.data["data"][this.state.currentInstance]["modified_text"],
                    rationale: this.state.data["data"][this.state.currentInstance]["rationale"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance]["modified_text_highlight_spans"]
                })
            }

            console.log("=> current state")
            console.log(this.state)

            const nQuestions = this.state.data["data"].length;
            this.n_questions = nQuestions
            console.log("[handleJson] There are", nQuestions, "questions.")

            this.answers = {
                "answers": new Array(nQuestions).fill(-1), 
                "question_details": Array.from({ length: nQuestions }, () => ({})),
                "question_types": new Array(nQuestions).fill(""),
                "labels": new Array(nQuestions).fill(""),
                "worker_modifications": new Array(nQuestions).fill(""),
                "explanations": new Array(nQuestions).fill("")
            }

            console.log("[handleJson] show class variables", this.state)
        }
        
    }

    handleBack() {
        // Go backward by changing current summary and sentence states.
        if (this.state.currentInstance > 0 ) {
            if (this.state.data["data"][this.state.currentInstance - 1]["task"] === "dialogue_contradiction_detection") {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance - 1]["uid"],
                    task: this.state.data["data"][this.state.currentInstance - 1]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance - 1]["original_last_turn"],
                    modified_text: this.state.data["data"][this.state.currentInstance - 1]["modified_last_turn"],
                    rationale: this.state.data["data"][this.state.currentInstance - 1]["rationale"],
                    original_conv_as_list: this.state.data["data"][this.state.currentInstance - 1]["original_conv_as_list"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["modified_text_highlight_spans"],
                    currentInstance: this.state.currentInstance - 1,
                })    
            } else if (this.state.data["data"][this.state.currentInstance - 1]["task"] === "conversational_qa") {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance - 1]["uid"],
                    task: this.state.data["data"][this.state.currentInstance - 1]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance - 1]["original_sentence"],
                    modified_text: this.state.data["data"][this.state.currentInstance - 1]["modified_text"],
                    rationale: this.state.data["data"][this.state.currentInstance - 1]["rationale"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["modified_text_highlight_spans"],
                    currentInstance: this.state.currentInstance - 1,
                }) 
            } else {
                this.setState({
                    uid: this.state.data["data"][this.state.currentInstance - 1]["uid"],
                    task: this.state.data["data"][this.state.currentInstance - 1]["task"],
                    original_text: this.state.data["data"][this.state.currentInstance - 1]["original_text"],
                    modified_text: this.state.data["data"][this.state.currentInstance - 1]["modified_text"],
                    rationale: this.state.data["data"][this.state.currentInstance - 1]["rationale"],
                    original_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["original_text_highlight_spans"],
                    modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance - 1]["modified_text_highlight_spans"],
                    currentInstance: this.state.currentInstance - 1,
                });
            }
        }
    }

    setOpenInstructions = (open) => {
        this.instructionsOpen = open;
    }

    handleChange(event) {
        let fieldName = event.target.name;
        let fieldValue = event.target.value;
        console.log("[handleChange] currentInstance:", this.state.currentInstance)

        if (fieldName.includes('correct-modification')) { // the "Yes"/"No" radio button
            console.log("[handleChange] modification correct?", fieldValue)
            // worker modification
            if (fieldValue === 'correct') {
                this.setState({worker_modification: "n/a"})
                this.setState({explanation: "n/a"})
            } else {
                this.setState({worker_modification: ''})
                this.setState({explanation: ""})
            }
            // 
            this.setState({
                correct: fieldValue === 'correct',
                selected: fieldValue
            })
        } else if (fieldName.includes('feedback')) {
            console.log("[handleChange] feedback:", fieldValue)
            this.setState({
                feedback: fieldValue
            })
        } else if (fieldName.includes('worker_modification')) {
            console.log("[handleChange] worker modification:", fieldValue)
            this.setState({
                worker_modification: fieldValue
            })
        } else if (fieldName.includes('explanation')) {
            console.log("[handleChange] explanation:", fieldValue)
            this.setState({
                explanation: fieldValue
            })
        }
    }

    handleNext(event) {
        // We don't want refresh page.
        event.preventDefault();
        event.stopPropagation();

        console.log("[handleNext] function invoked.")

        // submit result to MTurk and Firestore when all tasks are finished
        if (this.state.taskCompleted) {
            console.log("[handleNext] Task Completed.")
            this.answers['feedback'] = this.state.feedback;
            console.log("[handleNext] submitted answer:", this.answers)
            this.props.submitMainTask(this.answers, this.userData);
        } else {
            var answer = -1
            // Store answers if the task is under way.
            if (this.state.selected === 'correct') {
                answer = 1
                this.answers["answers"][this.state.currentInstance] = 1
            } else if (this.state.selected === 'incorrect') {
                answer = 0
                this.answers["answers"][this.state.currentInstance] = 0
            } else if (this.state.selected === 'unknown') {
                answer = 2
                this.answers["answers"][this.state.currentInstance] = 2
            }
            this.answers["worker_modifications"][this.state.currentInstance] = this.state.worker_modification
            this.answers["explanations"][this.state.currentInstance] = this.state.explanation
            
            this.props.saveRealTimeResult(answer, this.state.explanation, this.state.currentInstance)  // write answer to backend database

            // go to next question
            console.log("[handleNext] (before) current instance:", this.state.currentInstance)
            if (this.state.currentInstance >= this.n_questions - 1) {
                this.setState({ taskCompleted: true })
                // submit task directly after clicking the last "next" button.
                this.props.submitMainTask(this.answers, this.userData);
            } else {
                if (this.state.data["data"][this.state.currentInstance + 1]["task"] === "dialogue_contradiction_detection") {
                    this.setState({
                        uid: this.state.data["data"][this.state.currentInstance + 1]["uid"],
                        task: this.state.data["data"][this.state.currentInstance + 1]["task"],
                        original_text: this.state.data["data"][this.state.currentInstance + 1]["original_last_turn"],
                        modified_text: this.state.data["data"][this.state.currentInstance + 1]["modified_last_turn"],
                        rationale: this.state.data["data"][this.state.currentInstance + 1]["rationale"],
                        original_conv_as_list: this.state.data["data"][this.state.currentInstance + 1]["original_conv_as_list"],
                        original_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["original_text_highlight_spans"],
                        modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["modified_text_highlight_spans"]
                    })    
                } else if (this.state.data["data"][this.state.currentInstance + 1]["task"] === "conversational_qa") {
                    this.setState({
                        uid: this.state.data["data"][this.state.currentInstance + 1]["uid"],
                        task: this.state.data["data"][this.state.currentInstance + 1]["task"],
                        original_text: this.state.data["data"][this.state.currentInstance + 1]["original_sentence"],
                        modified_text: this.state.data["data"][this.state.currentInstance + 1]["modified_text"],
                        rationale: this.state.data["data"][this.state.currentInstance + 1]["rationale"],
                        original_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["original_text_highlight_spans"],
                        modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["modified_text_highlight_spans"]
                    }) 
                } else {
                    this.setState({
                        uid: this.state.data["data"][this.state.currentInstance + 1]["uid"],
                        task: this.state.data["data"][this.state.currentInstance + 1]["task"],
                        original_text: this.state.data["data"][this.state.currentInstance + 1]["original_text"],
                        modified_text: this.state.data["data"][this.state.currentInstance + 1]["modified_text"],
                        rationale: this.state.data["data"][this.state.currentInstance + 1]["rationale"],
                        original_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["original_text_highlight_spans"],
                        modified_text_highlight_spans: this.state.data["data"][this.state.currentInstance + 1]["modified_text_highlight_spans"]
                    });
                }
            }
            
            this.setState({ currentInstance: this.state.currentInstance + 1 });
            // console.log("[handleNext] (after) current instance:", this.state.currentInstance)

            // check answers
            console.log("answers:", this.answers)

            // reset current answer for new sentence.
            this.setState({
                correct_modification: true,
                selected: 'empty',
                feedback: '',
                worker_modification: 'n/a',
                explanation: 'n/a',
                currentInstance: this.state.currentInstance + 1
            })
        }
    }

    beginTask() {
        this.setState({
            readDirections: true
        });
    }


    render() {
        // console.log(this.state.data[this.state.currentInstance])
        // console.log("[render] current instance:", this.state.currentInstance)
        // console.log("[render] highlighted span:", this.state.summary.substring(this.state.highlight_start, this.state.highlight_end))
        // console.log("[render] highlight end char:", this.state.highlight_end)
        if (!this.state.taskCompleted) {
            return (
                <div>
                    <Container>
                        <Row>
                            <Col>
                                <Container>
                                    <Title />
                                    <Instructions
                                        open={this.instructionsOpen}
                                        setOpen={this.setOpenInstructions}
                                        bonus={queryDict.bonus}
                                        bonusMomentum={queryDict.bonusMomentum}
                                        long_instruction={this.state.instructions[queryDict.instruction_key]}
                                    />
                                </Container>
                            </Col>
                        </Row>
                    </Container>

                    <Container fluid>
                        <Row>
                            <Col>
                                <Container>
                                    <Row className="mb-3">
                                        <Col>
                                            {/* <Card className="mb-3" bg='warning'>
                                                <Card.Header>Directions</Card.Header>
                                                <Card.Body >
                                                    <Card.Title>Find Mistakes</Card.Title>
                                                    <Card.Text>
                                                        <b>Using the dialogue as ground-truth, check whether the <span className="currentSentence">highlighted</span> content in the summary is fully supported by the dialogue.</b><br />
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card> */}
                                            <Progress progress={Math.round(this.state.currentInstance / this.n_questions * 100)} />
                                        </Col>
                                    </Row>
                                </Container>
                                <Form onSubmit={this.handleNext}>
                                    <Container fluid>
                                        <Row className="mb-3">
                                            <Col>
                                                <ModificationInstruction
                                                    short_instruction={this.state.instructions[queryDict.instruction_key]}
                                                    task={this.state.task}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col>
                                                <SourceDoc
                                                    text={this.state.original_text}
                                                    highlight_spans={this.state.original_text_highlight_spans}
                                                />
                                            </Col>
                                            <Col>
                                                <ModifiedDoc
                                                    text={this.state.modified_text}
                                                    highlight_spans={this.state.modified_text_highlight_spans}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {/* <ModificationDetails
                                                    text={this.state.rationale}
                                                /> */}
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col>
                                                <Question
                                                    onSubmit={this.handleNext}
                                                    handleChange={this.handleChange}
                                                    selected={this.state.selected}
                                                    handleBack={this.handleBack}
                                                    worker_modification={this.state.worker_modification}
                                                    explanation={this.state.explanation}
                                                />
                                            </Col>
                                        </Row>
                                    </Container>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </div>
            );
        } else {
            return (
                // <Feedback
                //     handleChange={this.handleChange}
                //     onSubmit={this.handleNext}
                // />
                <TaskComplete/>
            )
        }
    }
}

export default MainTask;